export default __webpack_public_path__ + "static/media/viewspot-4.856a193e.png";